import { useMemo } from 'react';
import { useLocale } from '../context';
import { useSiteContent } from '../context/SiteContentContext';
import SiteErrorView from './SiteErrorView';

export default function RouteErrorFallback({ onRetry }) {
  const { locale } = useLocale();
  const { errorPages } = useSiteContent();
  const page = errorPages?.route || {};

  const title = useMemo(() => {
    if (locale === 'en') return page.titleEn || page.title || 'Page failed to load';
    return page.title || 'Sayfa yüklenemedi';
  }, [locale, page.title, page.titleEn]);

  const message = useMemo(() => {
    if (locale === 'en') {
      return page.messageEn || page.message || 'Something went wrong. Please refresh and try again.';
    }
    return page.message || 'Beklenmeyen bir hata oluştu. Yenileyip tekrar deneyin.';
  }, [locale, page.message, page.messageEn]);

  const buttonLabel = useMemo(() => {
    if (locale === 'en') return page.buttonEn || page.button || 'Refresh';
    return page.button || 'Yenile';
  }, [locale, page.button, page.buttonEn]);

  return (
    <SiteErrorView
      kind="route"
      title={title}
      message={message}
      buttonLabel={buttonLabel}
      buttonBg={page.buttonBg}
      buttonColor={page.buttonColor}
      onAction={onRetry}
    />
  );
}
